import React, { useState, useEffect } from "react";
import Loader from "components/Loader";
import { useParams } from "react-router-dom";
import TimelinePostList from "components/TimelinePostList";
import TeamService from "services/TeamService";
import { TimelineContext } from "store/contexts/timelineContext";

const styles = {
    heading: {
        fontWeight: 400,
        display: "flex",
        justifyContent: "center",
        marginBottom: "0px",
    },
    loaderStyle: {
        display: "flex",
        justifyContent: "center",
    },
};

function CompanyPost() {
    const classes = styles;
    const { postId, companyId } = useParams();
    const [total, setTotal] = useState("");
    const [loading, setLoading] = useState(true);
    const [post, setPost] = useState([]);

    const rootStyle = {
        display: " flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    };

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const response = await TeamService.getSingleCompanyPost(companyId, postId);

                console.log(response);
                setPost([response.data.data]);

                setTotal(1);
            } catch (e) {
                console.log(e);
            }
            setLoading(false);
        })();

    }, [postId, companyId]);

    const updatePost = (newPost) => {
        const postCopy = [...post];

        postCopy[
            postCopy.findIndex((tPost) => {
                return tPost.id === newPost.id;
            })
        ] = {
            ...newPost,
        };

        setPost(postCopy);
    };

    return (
        <TimelineContext.Provider
            value={{
                innovation_dashboard: true,
				company_id: companyId,
                updatePost,
            }}
        >
            {loading && (
                <div style={classes.loaderStyle}>
                    <Loader />
                </div>
            )}
            {!loading && (
                <div style={rootStyle} className="companyPostContent">
                    <h3 style={classes.heading}>Company post</h3>
                    <TimelinePostList posts={post} total={total} />
                </div>
            )}
        </TimelineContext.Provider>
    );
}

export default CompanyPost;